export const getPrimaryShopId = (user: any): number | null => {
    if (!user || typeof user !== "object") {
        return null;
    }

    const candidates: any[] = [
        user.shop_id,
        user.shopId,
        user.shop?.id,
        user.ownedShop?.id,
    ];

    if (Array.isArray(user.shops) && user.shops.length > 0) {
        candidates.push(user.shops[0]?.id);
    }

    for (const candidate of candidates) {
        const parsed = typeof candidate === "string" ? Number(candidate) : candidate;
        if (typeof parsed === "number" && !Number.isNaN(parsed) && parsed > 0) {
            return parsed;
        }
    }

    return null;
};

export const getPrimaryShopSlug = (user: any): string | null => {
    if (!user || typeof user !== "object") {
        return null;
    }

    const candidates: Array<string | null | undefined> = [
        user.shop_slug,
        user.shopSlug,
        user.shop?.slug,
        user.ownedShop?.slug,
    ];

    if (Array.isArray(user.shops) && user.shops.length > 0) {
        candidates.push(user.shops[0]?.slug);
    }

    for (const candidate of candidates) {
        if (typeof candidate === "string" && candidate.trim().length > 0) {
            return candidate.trim();
        }
    }

    return null;
};
